import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom"
import style from "./productList.module.scss";
import Searchbar from "../productSearchbar/productSearchbar";
import Button from "../../Components/Button/button";
import Dropdown from "../../Components/Dropdown/ButtonDropDown/DropDown";
import Progressbar from "../progressbar/progressbar"
import ProductCard from "./productCard/productCard";
import Pagination from "../pagination/pagination";
import Modal from "../Modal/Modal";
import Input from "../input/input";
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import Toast from "../../Components/Toast/Toast";
import GradientToast from "../gradientToast/Toast"
import {
    EditProductName,
    GetBrands,
    GetproductGroup,
    GetProductList,
    GetProgressbarData,
    GetSellers
} from "../../actions/APIcalls";
import toPersianNumber from "../../helpers/actions/toPersianNumber"
import ExpiredAccountWarning from "../expiredAccountWarning/expiredAccountWarning"
import DownGradeWarning from "../downGradeWarning/downGradeWarning";
import Skeleton from "../variantList/skeleton"

const ProductList = (props) => {
    const [hasSkeleton, setHasSkeleton] = useState(false)
    const [updateThreshold, setUpdateThreshold] = useState(0);
    const [toast, setToast] = useState('')
    const [errors, setErrors] = useState({})

    useEffect(async () => {
        let progressbarDataTemp = { ...progressbarData };
        if (updateThreshold % 30 === 0) {
            const resGetProgressbarData = await GetProgressbarData();
            if (resGetProgressbarData.data.AllVariantsCount === 0) {
                let initialData = {}
                const resGetSeller = await GetSellers();
                typeof resGetSeller !== "undefined" && typeof resGetSeller.data !== "undefined" ? initialData.channel = urlChecker(resGetSeller.data.channelList, "channel") : initialData.channel = [];
                (typeof resGetSeller !== "undefined" && typeof resGetSeller.response !== "undefined" && setToast(resGetSeller.response.data.error));
                progressbarDataTemp.inUpdateProccess = resGetSeller.data.channelList.length === 0 ? "noChannel" : "noProduct"
                setInitialData({ ...initialData })
            } else {
                if (resGetProgressbarData.data.percent === 100) {
                    getInitialData();
                    getProductListSalim();
                    progressbarDataTemp.inUpdateProccess = false;
                } else {
                    progressbarDataTemp = Object.assign(progressbarDataTemp, resGetProgressbarData.data);
                    progressbarDataTemp.inUpdateProccess = "true";
                    setTimeout(() => {
                        setUpdateThreshold(updateThreshold + 1);
                    }, 1000);
                }
            }
            progressbarDataTemp.timer = 0;
        } else {
            setTimeout(() => {
                progressbarDataTemp.remainTime > 0 ? progressbarDataTemp.remainTime - progressbarData.timer <= 0 ? setUpdateThreshold(0) : setUpdateThreshold(updateThreshold + 1) : setUpdateThreshold(updateThreshold + 1);
                progressbarDataTemp.timer++;
            }, 1000);
        }
        setProgressbarData(progressbarDataTemp);
    }, [updateThreshold]);
    useEffect(() => {
        getProductListSalim()
        console.log(props.history.location.search);
    }, [props.history.location])
    const getFromUrl = (param) => {
        const defaultParams = {
            brand: [],
            channel: [],
            productGroup: [],
            countInPage: 10,
            page: 1,
            query: ""
        }
        let url = new URLSearchParams(window.location.search);
        if (url.get(param)) {
            if (param === "brand" || param === "productGroup" || param === "channel") {
                return url.get(param).split("*");
            } else {
                return url.get(param);
            }
        } else {
            return defaultParams[param];
        }
    }
    const setToUrl = (param, value) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            url.set(param, tempString);
        } else {
            url.set(param, value);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        return 1;
    }
    const urlChecker = (list, tag) => {
        // todo salim need to add brand  logic
        let tempList = [];
        let filters = getFromUrl(tag);
        list.map(item => {
            if (filters.indexOf(tag === "channel" ? item._id : item.name ? item.name : item) >= 0) {
                tempList.push({ name: item.name ? item.name : item, checked: true, _id: item._id ? item._id : "" });
            } else {
                tempList.push({ name: item.name ? item.name : item, checked: false, _id: item._id ? item._id : "" });
            }
        })
        return tempList;
    }
    const filterIsActive = () => {
        let bool = false;
        ["brand", "channel", "productGroup"].map(filter => {
            if (getFromUrl(filter).length > 0) {
                bool = true;
            }
        })
        return bool;
    }
    const searchHandler = (tag, value) => {
        let initialDataTemp = { ...initialData };
        initialDataTemp[`${tag}Search`] = value;
        setInitialData(initialDataTemp);
    }
    const searcher = (list, key) => {
        let searchedList = []
        if (key) {
            list.map(item => {
                if (item.name.includes(key)) {
                    searchedList.push(item);
                }
            })
            // todosalim need tp handle emty search
            return searchedList;
        } else {
            return list;
        }
    }
    const timeCalc = (remainTime) => {
        let min = Math.floor((remainTime - progressbarData.timer) / 60);
        let second = Math.floor((remainTime - progressbarData.timer) % 60);
        if (Math.floor(remainTime - progressbarData.timer) <= 0) {
            return toPersianNumber("00") + ":" + toPersianNumber("00")
        } else {
            return toPersianNumber(min.toString().length === 1 ? "0" + min : min) + ":" + toPersianNumber(second.toString().length === 1 ? "0" + second : second)
        }
    }

    //progress logic
    const [progressbarData, setProgressbarData] = useState({ inUpdateProccess: "true", timer: 0 });

    const [initialData, setInitialData] = useState({
        brand: [],
        channel: [],
        productGroup: [],
        brandSearch: "",
        channelSearch: "",
        productGroupSearch: ""
    });
    const getInitialData = async () => {
        let initialData = {}
        const resGetSeller = await GetSellers();
        typeof resGetSeller !== "undefined" && typeof resGetSeller.data !== "undefined" ? initialData.channel = urlChecker(resGetSeller.data.channelList, "channel") : initialData.channel = [];
        (typeof resGetSeller !== "undefined" && typeof resGetSeller.response !== "undefined" && setToast(resGetSeller.response.data.error));
        const resGetGroups = await GetproductGroup();
        typeof resGetGroups !== "undefined" && typeof resGetGroups.data !== "undefined" ? initialData.productGroup = urlChecker(resGetGroups.data.GroupList, "productGroup") : initialData.productGroup = [];
        (typeof resGetGroups !== "undefined" && typeof resGetGroups.response !== "undefined" && setToast(resGetGroups.response.data.error));
        const resGetBrands = await GetBrands();
        typeof resGetBrands !== "undefined" && typeof resGetBrands.data !== "undefined" ? initialData.brand = urlChecker(resGetBrands.data.BrandList, "brand") : initialData.brand = [];
        (typeof resGetBrands !== "undefined" && typeof resGetBrands.response !== "undefined" && setToast(resGetBrands.response.data.error));

        initialData.inUpdateProccess = false;
        setInitialData({ ...initialData })
    }
    const [productData, setProductData] = useState({ productList: [], pageCount: 10 });
    const getProductListSalim = async (filter) => {
        setHasSkeleton(true)
        let paramsFromUrl = {
            brand: getFromUrl('brand'),
            productGroup: getFromUrl('productGroup'),
            channel: getFromUrl('channel'),
            page: filter ? setToUrl("page", 1) : getFromUrl('page'),
            countInPage: getFromUrl('countInPage'),
            query: getFromUrl('query')
        }
        let temp = [];
        if (paramsFromUrl.channel) {
            const res = await GetSellers();
            paramsFromUrl.channel.map(id => {
                temp.push(res.data.channelList.find(item => item._id === id)._id);
            })
        }
        paramsFromUrl.channel = temp;
        const resGetList = await GetProductList(paramsFromUrl);
        if (resGetList.status === 200) {
            setProductData({
                productList: resGetList.data.productList,
                pageCount: resGetList.data.productListPageCount,
                count: resGetList.data.productCount
            })
        }
        setHasSkeleton(false)
    }

    // handlers**********************************************************
    const filterHandler = (value, tag) => {
        setToUrl(tag, value);
        if (tag !== "page") {
            setToUrl("page", 1);
        }
        getProductListSalim();
    }
    const deleteFiletrsHandler = (filterList) => {
        let initialDataTemp = { ...initialData };
        filterList.map(filter => {
            setToUrl(filter, "");
            let temp = [];
            initialDataTemp[filter].map((item) => {
                temp.push({ ...item, checked: false });
            })
            initialDataTemp[filter] = temp;
        });
        setInitialData(initialDataTemp);
        getProductListSalim();
    }
    // end salim logic new
    //modals
    const [editNameModal, setEditNameModal] = useState({
        open: false,
        value: "",
        err: "",
        id: "",
        channelId: "",
        parentId: "",
        success: false
    });
    const [editGroupModal, setEditGroupModal] = useState({ open: false, err: "", id: "", channelId: "", success: false });
    const [deleteGroupModal, setDeleteGroupModal] = useState({
        open: false,
        err: "",
        id: "",
        channelId: "",
        success: false
    });
    const [groupModal, setGroupModal] = useState({
        open: false,
        err: "",
        value: [{ name: "کد کالای دوم", value: "", tag: "0" }],
        id: "",
        channelId: "",
        success: false
    });

    //setDataToServer****************************************************************************************************************
    const editProductName = async () => {
        if (editNameModal.value) {
            let params = { productId: editNameModal.id, channelId: editNameModal.channelId, newName: editNameModal.value }
            let res = EditProductName(params)
            if (res) {
                let temp2 = editNameModal;
                temp2.success = true;
                setEditNameModal({ ...temp2 })
            }
        } else {
            let temp = editNameModal;
            temp.err = "تکمیل این فیلد الزامیست"
            setEditNameModal({ ...temp })
        }
    }


    //handlers *********************************************************************************************************************
    const modalsHandler = (tag, id, channelId, parentId) => {

        let editName = editNameModal;
        if (typeof props.user !== "undefined" && props.user.permission.productList.includes("Edit")) {

            switch (tag) {
                case "editName": {
                    editName.id = id;
                    if (typeof parentId !== "undefined") editName.parentId = parentId;
                    editName.channelId = channelId;
                    editName.open = true;
                    setEditNameModal({ ...editName });
                    cancelModal("group", groupModal, setGroupModal)
                    cancelModal("editGroup", editGroupModal, setEditGroupModal)
                    cancelModal("deleteGroup", deleteGroupModal, setDeleteGroupModal)

                    break;
                }
            }
        }
    }

    const handleSelect = (tag, value) => {
        let initialDataTemp = { ...initialData };
        let urlGroups = getFromUrl(tag);
        if (value.checked) {
            urlGroups.splice(urlGroups.indexOf(tag === "channel" ? value._id : value.name), 1);
        } else {
            urlGroups.push(tag === "channel" ? value._id : value.name ? value.name : value)
        }
        setToUrl(tag, urlGroups);
        initialDataTemp[tag] = urlChecker(initialData[tag], tag);
        // todosalim need to test for brand and channel
        setInitialData(initialDataTemp);
    }

    const onchangeHandler = (tag, value, secondTag) => {
        switch (tag) {
            case "editName":
                let temp = editNameModal;
                temp.value = value.target.value;
                setEditNameModal({ ...temp });
                break;

        }
    }
    const onBlureHandler = () => {
    }

    //JSX RENDERER*******************************************************************************************************************************
    const ButtonPackRenderer = (maintag, canceltag, mainlabel, mainaction, get, set) => {
        return (
            <div className={style.buttonPack}>
                < Button
                    disabled={false}
                    tag={canceltag}
                    type="outline"
                    label="انصراف"
                    onclick={() => {
                        cancelModal(maintag, get, set);
                        setErrors({});
                        setToast('')
                    }} />
                < Button
                    disabled={false}
                    tag={maintag}
                    type="solid"
                    label={mainlabel}
                    onclick={() => mainaction()}
                />
            </div>
        )
    }
    const modalRenderer = (tag) => {
        switch (tag) {
            case "editName": {
                let temp;
                // if (editNameModal.parentId !== "") {
                //     let temp1 = productData.productList.find(product => product._id === editNameModal.parentId);
                //     temp = temp1.mergedProduct.find(e => e._id === editNameModal.id);
                // }
                // else {
                temp = productData.productList.find(product => product._id === editNameModal.id);
                // }
                if (editNameModal.success) {
                    return <div className={style.nameEditSuccess}>
                        <p className={style.successIcon}>f</p>
                        <p>.ویرایش نام کالا با موفقیت انجام شد</p>
                        < Button
                            tag="confirm"
                            type="solid"
                            label="تایید"
                            onclick={() => {
                                setEditNameModal({ open: false });
                                getProductListSalim();
                                setToast('')
                            }}
                        />
                    </div>
                } else {
                    return (
                        <div className="d-flex justify-content-center">
                            <div className={style.editName}>
                                <p style={{ direction: "rtl" }}>{temp.newName}</p>
                                <Input
                                    label="نام جدید کالا"
                                    placeholder="نام جدید کالا"
                                    tag="editName"
                                    value={editNameModal.value}
                                    error={editNameModal.err}
                                    // tooltip={"ایمیل ثبت شده در پنل فروشندگان دیجی‌کالا"}
                                    onchange={onchangeHandler}
                                    onblur={onBlureHandler}
                                />
                            </div>
                            {ButtonPackRenderer("editName", "editNameCancel", "ثبت تغییرات", editProductName, editNameModal, setEditNameModal)}
                        </div>
                    )
                }

            }
        }
    }
    //function ************************************************************
    const cancelModal = (tag, get, set) => {
        let modal = get;
        modal.id = "";
        modal.channelId = "";
        modal.open = false;
        modal.success = false;
        modal.err = false;
        modal.value = ""
        if (tag == "group") {
            modal.value = [{ name: "کد کالای دوم", value: "", tag: "0" }];
        }
        set({ ...modal });

    }
    const closeModalFunction = () => {
        setToast('')
    }
    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                <Toast
                    tag='Toast'
                    text={toast}
                    value={toast ? true : false}
                    parentClose={closeModalFunction}
                />
                {
                    props.user.expiredAccount && <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                {/* {
                    Object.keys(props.user.downGradeWarning).length !== 0 &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <DownGradeWarning data={{ ...props.user.downGradeWarning }} />
                            </>
                        </GradientToast>
                    </div>
                } */}
                {editNameModal.open ?
                    <Modal
                        tag="editname"
                        value={editNameModal.open ? true : false}
                        title="ویرایش نام کالا"
                        parentClose={() => {
                            cancelModal("editName", editNameModal, setEditNameModal);
                            setToast('')
                        }}>
                        {modalRenderer("editName")}

                    </Modal> : <div></div>}

                <div className={style.headerRow}>
                    <h3>کالاهای ثبت شده</h3>
                </div>
                <div className={style.expiredAccountWrapper}>
                    {/* {
                    props.user.expiredAccount &&
                    <ExpiredAccountWarning/>
                }
                {
                    Object.keys(props.user.downGradeWarning).length !== 0 &&
                    <DownGradeWarning data={{...props.user.downGradeWarning}}/>
                } */}
                </div>
                {progressbarData.inUpdateProccess ?
                    <div className={style.empty}>
                        {progressbarData.inUpdateProccess === "noProduct" || progressbarData.inUpdateProccess === "noChannel" ?
                            (initialData.channel.length > 0 ?
                                <React.Fragment>
                                    <div className={style.image}>d</div>
                                    <p className={style.boldText}>.کاربر عزیز، در حال حاضر شما هیچ کالایی در ربات موبیشا
                                        ندارید</p>
                                    <p>.شما می‌توانید لیست کالاهای خود را از صفحه تنوع‌ها به‌روز رسانی کنید</p>
                                    <Button
                                        tag="goTo "
                                        type="solid"
                                        label="صفحه لیست تنوع‌ها"
                                        onclick={() => {
                                            props.history.push("/variants")
                                        }} />
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <div className={style.image}>l</div>
                                    <p className={style.boldText}>.کاربر عزیز، شما تاکنون هیچ پنلی ثبت نکرده‌اید</p>
                                    <p>.شما می‌توانید با ثبت پنل دیجی‌کالای خود، کار با ربات موبیشا را شروع کنید </p>
                                    <Button type="solid"
                                        label={" ورود به صفحه پنل دیجی کالا"}
                                        onclick={() => props.history.push("/channels")} />
                                </React.Fragment>
                            )
                            : <React.Fragment>
                                <p className={style.boldText}>.کاربر عزیز، در حال حاضر محصولات در دسترس نیست</p>
                                <p>.محصولات درحال بروز رسانی میباشد</p>
                                <div className={style.progressbarwrapperDown}>
                                    <Progressbar width={parseInt(progressbarData.percent)} />
                                    <div className={style.textRow}>
                                        <p className={style.text}>
                                            {toPersianNumber(progressbarData.receivedVariantsCount)}
                                            {" "} کالا از{" "}
                                            {toPersianNumber(progressbarData.AllVariantsCount)}
                                            {" "}کالا دریافت شد.{" "}
                                        </p></div>
                                    < div className={style.time}>{timeCalc(progressbarData.remainTime)}</ div>
                                </div>
                            </React.Fragment>}
                    </div>
                    : <React.Fragment>
                        <div className={style.searchbarWrapper}>
                            <Searchbar
                                searchValue={filterHandler}
                                tag="query"
                                value={getFromUrl("query") ? getFromUrl("query") : ""}
                                placeholder={"عنوان یا کد کالا"} />
                        </div>
                        <div className={style.dropdownWrapper}>
                            {filterIsActive() ? <div className={style.deleteAll} onClick={() => {
                                deleteFiletrsHandler(["brand", "channel", "productGroup"])
                            }}>g</div> : <div></div>}
                            <div className={style.dropdownBox}>
                                <Dropdown
                                    tag='productGroup'
                                    label='گروه محصول'
                                    placeHolder='گروه محصول'
                                    dropdownList={searcher(initialData.productGroup, initialData.productGroupSearch)}
                                    hasSearchBox={true}
                                    hasCheckbox={true}
                                    handleSearch={searchHandler}
                                    deleteSelectedItems={() => deleteFiletrsHandler(["productGroup"])}
                                    handleSelect={handleSelect}
                                    action={getProductListSalim}
                                />
                            </div>
                            <div className={style.dropdownBox}>
                                <Dropdown
                                    tag='brand'
                                    label='برند'
                                    placeHolder='برند'
                                    dropdownList={searcher(initialData.brand, initialData.brandSearch)}
                                    hasSearchBox={true}
                                    hasCheckbox={true}
                                    handleSearch={searchHandler}
                                    deleteSelectedItems={() => deleteFiletrsHandler(["brand"])}
                                    handleSelect={handleSelect}
                                    action={getProductListSalim}

                                /></div>
                            {initialData.channel.length > 1 ?
                                <div className={style.dropdownBox}>
                                    <Dropdown
                                        tag='channel'
                                        label='فروشنده'
                                        placeHolder='فروشنده'
                                        dropdownList={searcher(initialData.channel, initialData.channelSearch)}
                                        hasSearchBox={true}
                                        hasCheckbox={true}
                                        handleSearch={searchHandler}
                                        deleteSelectedItems={() => deleteFiletrsHandler(["channel"])}
                                        handleSelect={handleSelect}
                                        action={getProductListSalim}
                                    /></div>
                                : <div></div>}
                        </div>
                        {productData.productList.length === 0 ?
                            <div className={style.noResult}>
                                <div className={style.image}>
                                    O
                                </div>
                                <p className={style.boldText}>!نتیجه‌ای یافت نشد</p>
                                <p>.نتیجه‌ای مطابق با جستجوی شما یافت نشد. لطفا عبارت دیگری را امتحان کنید</p>
                            </div>
                            : <div className={style.cardComponents}>
                                <div className={style.pagination}>
                                    <Pagination currentPage={parseInt(getFromUrl("page"))}
                                        pageCount={parseInt(productData.pageCount)} tag={"page"}
                                        setPage={filterHandler} />
                                    <div className={style.Dropdown}>

                                        <TinyDropdown placeholder={getFromUrl("countInPage")}
                                            dropdownList={["10", "25", "50", "75", "100"]}
                                            selected={selected => filterHandler(selected, "countInPage")} />
                                        <div className={style.label}>تعداد نمایش در صفحه</div>
                                        <div className={style.verticalLine}></div>
                                        <div
                                            className={style.productCount}>{toPersianNumber(productData.count) + " کالا"}</div>

                                    </div>
                                </div>
                                {productData.productList.map((product, index) => {
                                    return <ProductCard key={index} data={product} modalsHandler={modalsHandler} />
                                })}
                                <div className={style.paginationTwo}>
                                    <Pagination currentPage={parseInt(getFromUrl("page"))}
                                        pageCount={parseInt(productData.pageCount)} tag={"page"}
                                        setPage={filterHandler} />
                                </div>
                            </div>}
                    </React.Fragment>}
            </div>
        )
    }
}

export default withRouter(ProductList);